module.exports = __webpack_public_path__ + "biao21.jpg?95eb2ad";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/biao/biao21.jpg
 ** module id = 57
 ** module chunks = 0
 **/